function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import qs from 'query-string';
import { ExtendableBuiltin } from './utils';

var signatureCallback = null;

export var APIError = function (_ExtendableBuiltin) {
  _inherits(APIError, _ExtendableBuiltin);

  function APIError(message, response, data) {
    _classCallCheck(this, APIError);

    var _this = _possibleConstructorReturn(this, (APIError.__proto__ || Object.getPrototypeOf(APIError)).call(this, message));

    _this.name = _this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }
    _this.response = response;
    _this.data = data;
    return _this;
  }

  return APIError;
}(ExtendableBuiltin(Error));

export var initApi = function initApi(callback) {
  signatureCallback = callback;
};
export function fixUrl(url) {
  return url.replace(/\/$/, '').replace(/([^:]\/)\/+/g, '$1');
}

export var queryUrl = function queryUrl(url, obj) {
  return url + '?' + qs.stringify(obj);
};

function signRequest(url, originalOptions, _ref) {
  var username = _ref.username,
      password = _ref.password,
      comment = _ref.comment;

  var authHeaders = {
    'x-sig-usr': encodeURI(username),
    'x-sig-pw': password,
    'x-sig-com': comment && encodeURI(comment) || ''
  };
  var headers = Object.assign({}, originalOptions.headers || {}, authHeaders);
  return apiFetch(url, Object.assign({}, originalOptions, { headers: headers })) // eslint-disable-line
  .then(function (response) {
    // If we get any error message from backend return response as json
    // Need to figure this out. When shall we return json?
    // Needed for show module.user.alternate.required in ES dialog but NOT for module.profile.trial.active & module.trial.invalid.status
    // if ( response.status === 409 && response.headers.get( 'content-type' ).match( /application\/json/ ) ) {
    //   return toJSON( response ); // eslint-disable-line
    // }
    if (response.status === 500) {
      return checkResponseOk(response); // eslint-disable-line
    }
    return response;
  });
}

/**
 *
 * @param apiPath - will be omitted for production
 * @param productionUrl  - will be omitted for development
 * @param basePath
 * @param options
 * @param metaOptions
 * @returns {Promise<T>}
 */
export var apiGenericFetch = function apiGenericFetch(apiPath, productionUrl, basePath, options) {
  var metaOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var u = '';
  var path = '';
  if (process.env.NODE_ENV === 'production') {
    u = productionUrl + '/' + basePath;
    path = '';
  } else {
    u = '/' + apiPath + '/' + basePath;
  }
  return fetch(fixUrl('' + (path || '') + u), options).then(function (response) {
    if (response.status === 401 && metaOptions.noAuthRedirect !== true) {
      // User is not authenticated / timed out. Redirect to home ( which should redirect to login automatically )
      var targetLocation = window.location.protocol + '//' + window.location.host + '/';

      // Hack to "recreate" the redirectLink query param (to preserve links through login)
      var searchStr = window.location.search;
      if (searchStr !== '') {
        var queryParams = searchStr.substr(1).split('&');
        for (var v in queryParams) {
          var keyVal = queryParams[v].split('=');
          if (keyVal[0] === 'redirectLink') {
            targetLocation += '?' + queryParams[v];
          }
        }
      }
      if (targetLocation !== window.location.toString() && window.location.pathname !== '/login') {
        window.location = targetLocation;
      }
      return Promise.reject(new APIError('Request not authenticated', response));
    }
    if (response.status === 403) {
      var signatureRequired = response.headers.get('x-signature-required');
      if (signatureRequired && signatureCallback) {
        var originalOptions = options;
        var originalUrl = u;
        return new Promise(function (resolve, reject) {
          response.json().then(function (json) {
            signatureCallback(json.signatureDescription, function (err, signData) {
              if (err) {
                return reject(err);
              }
              if (!signData) {
                return reject();
              }
              var username = signData.username,
                  password = signData.password,
                  comment = signData.comment;


              return signRequest(originalUrl, originalOptions, {
                username: username,
                password: password,
                comment: comment
              }).then(function (result) {
                if (result.status === 200 || result.status === 201 || result.status === 400 || result.status === 409 || result.status === 412) {
                  resolve(result);
                }
                return result;
              }).catch(function (result) {
                reject(result);
                return Promise.reject(result);
              });
            });
          });
        });
      }
    }
    return response;
  });
};

export var apiFetch = function apiFetch(url, options) {
  var metaOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return apiGenericFetch('' + (process.env.REACT_APP_API_PATH || ''), url, options, metaOptions);
};

export var toJSON = function toJSON(response) {
  if (!response.headers.get('content-type').match(/application\/json/)) {
    return Promise.reject();
  }
  return response.json();
};

export var checkResponseOk = function checkResponseOk(response) {
  if (!response.ok) {
    var contentType = response.headers.get('content-type') || '';
    if (contentType.match(/application\/json/)) {
      return toJSON(response).then(function (json) {
        return Promise.reject(new APIError('Response not ok', response, json));
      });
    }
    return Promise.reject(new APIError('Response not ok', response));
  }
  return response;
};

export var redirectAPIErrors = function redirectAPIErrors(history) {
  return function (apiError) {
    if (apiError && apiError.response) {
      if (apiError.response.status === 403) {
        history.push('/error/403');
      } else if (apiError.response.status === 500) {
        history.push('/error/500');
      } else if (apiError.response.status === 412) {
        throw apiError;
      }
    }

    // HACK! TODO: FIXME! We are swallowing exceptions here. Need to be sent upstream when we have time to go through all pages and assert that error messages are being displayed
  };
};

/**
 * Wraps a data fetcher function and compares the expected nr of records with the acutally received nr of records.
 * Will re-fetch with offset set to 0 if no records found
 */
export var pagedResultWrapper = function pagedResultWrapper(fetcher) {
  return new Promise(function (resolve, reject) {
    fetcher().then(function (_ref2) {
      var data = _ref2.data,
          metaData = _ref2.metaData;

      if (Array.isArray(data) && data.length === 0 && metaData.totalCount && parseInt(metaData.totalCount, 10) > 0) {
        // Assume we are getting the wrong page. Force override offset
        fetcher({ offset: 0 }).then(resolve).catch(reject);
      } else {
        resolve({ data: data, metaData: metaData });
      }
    }).catch(reject);
  });
};

export var GET = {
  method: 'GET',
  credentials: 'include',
  headers: {}
};

export var POST = {
  method: 'POST',
  credentials: 'include',
  headers: {
    'content-type': 'application/json'
  }
};

export var PUT = {
  method: 'PUT',
  credentials: 'include',
  headers: {
    'content-type': 'application/json'
  }
};

export var PATCH = {
  method: 'PATCH',
  credentials: 'include',
  headers: {
    'content-type': 'application/json'
  }
};

export var DELETE = {
  method: 'DELETE',
  credentials: 'include',
  headers: {}
};

export var headerOptionsGET = function headerOptionsGET(header) {
  if (header) {
    return {
      method: GET.method,
      credentials: GET.credentials,
      headers: Object.assign({}, header, GET.headers)
    };
  }
  return GET;
};

export var headerOptionsPOST = function headerOptionsPOST(header) {
  if (header) {
    return {
      method: POST.method,
      credentials: POST.credentials,
      headers: Object.assign({}, header, POST.headers)
    };
  }
  return POST;
};

export var headerOptionsPUT = function headerOptionsPUT(header) {
  if (header) {
    return {
      method: PUT.method,
      credentials: PUT.credentials,
      headers: Object.assign({}, header, PUT.headers)
    };
  }
  return PUT;
};

export var headerOptionsPATCH = function headerOptionsPATCH(header) {
  if (header) {
    return {
      method: PATCH.method,
      credentials: PATCH.credentials,
      headers: Object.assign({}, header, PATCH.headers)
    };
  }
  return PATCH;
};

export var headerOptionsDELETE = function headerOptionsDELETE(header) {
  if (header) {
    return {
      method: DELETE.method,
      credentials: DELETE.credentials,
      headers: Object.assign({}, header, DELETE.headers)
    };
  }
  return DELETE;
};